<template>
  <div class="">
    <el-dialog title="" :visible.sync="isShowChatImage" width="30%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Image Preview
        </h3></template
      >
      <!-- <div v-for="(item, index) in getcomments" class="mt-4" :key="index"> -->
      <div>
        <img :src="imagePreview" class="w-full" alt="image" />
      </div>
      <!-- </div> -->

      <!-- <div>
        <div class="flex justify-end">
          <b-button variant="primary" class="mt-8 px-8 py-3">Submit</b-button>
        </div>
      </div> -->
    </el-dialog>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">Review</h3></template
      >
      <div class="text-center">
        <h3 class="fsize21 font-semibold text-dark">
          Your opinoion matter to us
        </h3>
        <div class="bg-fas rounded-lg mt-4 mb-2 bordb p-6">
          <p class="text-gray fsize14 mb-3">How was the quality calls?</p>
          <el-rate v-model="value1"></el-rate>
          <el-input
            type="textarea"
            :rows="2"
            class="mt-4"
            placeholder="Please input"
            v-model="textarea"
          >
          </el-input>
          <div class="grid grid-cols-2 gap-4 w-full mt-4">
            <vs-button
              type="primary"
              v-if="isEditFeedback"
              class="bg-primary w-full"
              @click="editFeedback()"
              >Update</vs-button
            >
            <vs-button
              type="primary"
              class="bg-primary w-full"
              v-else
              @click="addFeedback()"
              >Submit</vs-button
            >
            <vs-button
              type="secondary"
              class="bg-secondary w-full"
              @click="closeFeedback()"
              >Skip</vs-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title=""
      :visible.sync="centerDialogVisible1"
      width="30%"
      center
      class="ne-oppo-new"
    >
      <SendPopUp />
    </el-dialog> -->
    <el-dialog
      title=""
      :visible.sync="isFileType"
      width="30%"
      center
      class="headerbg"
    >
      <div class="text-center">
        <div class="mb-5 mx-auto rounded-full">
          <img
            :src="showImage('Admin/Assets/Folder.png')"
            alt=""
            class="h150px"
          />
        </div>
        <span class="text-center font-semibold text-black fsize20 mb-4 mt-6"
          >File type should be jpg/jpeg/png/pdf!</span
        >
      </div>

      <div class="w-full justify-center pt-3 pb-6 flex">
        <vs-button
          color="primary"
          class="bg-primary px-12"
          @click="isFileType = false"
          >Okay</vs-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="isFileSize"
      width="30%"
      center
      class="headerbg"
    >
      <div class="text-center">
        <div class="mb-5 mx-auto rounded-full">
          <img
            :src="showImage('Admin/Assets/Folder.png')"
            alt=""
            class="w150px"
          />
        </div>
        <span class="text-center font-semibold text-black fsize20 mb-4 mt-6"
          >File size exceed, upload file less than 3MB</span
        >
      </div>

      <div class="w-full justify-center pt-4 pb-6 flex">
        <vs-button
          color="primary"
          class="bg-primary px-12"
          @click="isFileSize = false"
          >Okay</vs-button
        >
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="object-cover bg-primary ban-marcom60 w-full"></div>
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
        </div>
      </div>
    </div>

    <div class="w-full flex bg-white px-6 py-8">
      <div class="w-1/3">
        <div class="cust-shadow rounded-10px bg-white">
          <div class="p-4 mb-4">
            <div>
              <img
                :src="showImage(selectedreq.request.image)"
                class="object-contain bg-f9 w-full heighjk rounded-4px"
                alt="banh"
              />
            </div>

            <div class="mt-4">
              <div class="flex justify-between items-center">
                <h3 class="fsize18 mb-0 text-black font-semibold">
                  {{ selectedreq.request.name }}
                </h3>

                <el-tag type="success" class="rounded-full px-4">
                  {{ selectedreq.status }}
                </el-tag>
              </div>

              <p class="fsize12 mb-2">
                <span class="text-danger font-semibold"
                  >Requested:<span class="text-8f8f8f pl-1 font-medium">{{
                    getDate(selectedreq.createdAt)
                  }}</span></span
                >
              </p>

              <!-- <h4 class="font-semibold text-primary mb-2 mt-4 fsize14">
                Additional Comments:
              </h4>
              <p class="font-medium text-8f8f8f my-0 fsize12">
                {{ selectedreq.request.description }}
              </p> -->
            </div>
            <!-- Image download -->
            <div class="gap-4 items-center">
              <div
                class="flex items-center justify-between w-full mt-2"
                v-for="(i, index) in selectedreq.uploadHistory"
                :key="index"
              >
                <img
                  :src="
                    i.isPdf
                      ? showImage('Admin/Assets/pdfIcon2.png')
                      : showImage(`${selectedProject.projectName}${i.file}`)
                  "
                  @click="getImage(`${selectedProject.projectName}${i.file}`)"
                  class="object-contain w-16 h-16"
                  alt="img"
                />

                <div class="w-full pl-4">
                  <h3 class="col-4f fsize14 font-medium mb-0">
                    {{ i.fileName }}
                  </h3>
                  <h6 class="col-4f fsize12 font-medium mb-0">
                    {{ getDate(i.uploadDate) }}
                  </h6>
                </div>

                <div class="pr-2 cursor-pointer">
                  <feather-icon
                    class="text-8f8f8f"
                    icon="DownloadIcon"
                    @click="downloadImg(i.file, i.fileName)"
                  />
                </div>
              </div>
            </div>

            <p class="fsize12 mt-4" v-if="selectedreq.isSignOff">
              <span class="text-success font-medium"
                >Delivered:<span class="text-8f8f8f pl-1 font-medium">{{
                  getDate(selectedreq.deliveredDate)
                }}</span></span
              >
            </p>
            <div
              v-if="
                selectedreq.isSignOff &&
                selectedreq.hasOwnProperty('feedback') &&
                selectedreq.feedback.length
              "
            >
              <h6 class="font-semibold text-primary mb-2 mt-4 fsize14">
                Feedback:
              </h6>
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                v-if="selectedreq.feedback.length < 2"
                @click="editFeedBackPopup()"
              />
              <div>
                <el-rate
                  v-if="selectedreq.feedback.length == 2"
                  v-model="selectedreq.feedback[1].feedbackRating"
                ></el-rate>
                <el-rate
                  v-else
                  v-model="selectedreq.feedback[0].feedbackRating"
                ></el-rate>
                <p class="font-medium text-8f8f8f my-0 fsize12">
                  {{
                    selectedreq.feedback.length == 2
                      ? selectedreq.feedback[1].feedbackDes
                      : selectedreq.feedback[0].feedbackDes
                  }}
                </p>
              </div>
            </div>
            <vs-button
              @click="editRequest"
              :disabled="!isActive || !this.selectedreq.uploadHistory.length"
              class="bg-primary text-white w-full font-medium fsize14 py-4 px-10 mt-4 sm-fsize14 rounded-full"
            >
              Sign-off & Accept deliverables
            </vs-button>
          </div>
        </div>
      </div>
      <div class="w-8/12 pl-8 rounded-lg">
        <div class="cust-shadow relative h-90vh rounded-10px">
          <div>
            <div class="border-b p-6">
              <h4 class="font-semibold text-primary fsize18 mb-0">
                Order # {{ selectedreq.orderId }}
              </h4>
            </div>

            <div class="p-6">
              <!-- chat module -->
              <div class="chatscroll" id="chatwindow" ref="chat">
                <div
                  v-for="(item, index) in getcomments"
                  class="mt-4"
                  :key="index"
                >
                  <div
                    class="widthprim-chats"
                    v-if="item.commentOrigin === 'Cera'"
                  >
                    <!-- cera -->
                    <div
                      class="font-medium text-white fsize12 mb-0 rounded-lg fitcontent bg-primary p-4 w-50"
                    >
                      <div
                        v-if="item.hasOwnProperty('commentImage')"
                        @click="isShowChatImage = true"
                        class="bg-primary"
                      >
                        <img
                          :src="showImage(item.commentImage)"
                          class="chat-imgset object-contain w-full"
                          alt="image"
                          @click="getImage(item.commentImage)"
                        />
                      </div>
                      <p>
                        {{ item.comment }}
                      </p>
                    </div>
                    <span class="fsize10 text-8f8f8f flex justify-start pt-2">{{
                      getDate(item.createdAt)
                    }}</span>
                  </div>

                  <div
                    class="mt-4 flex justify-end mr-4"
                    v-if="item.commentOrigin === 'Admin'"
                  >
                    <div>
                      <div class="rounded-lg text-right bg-f4f5f6">
                        <!-- admin -->
                        <div
                          v-if="item.hasOwnProperty('commentImage')"
                          class="rounded-lg text-right bg-f4f5f6"
                        >
                          <img
                            :src="
                              item.isPdfUpload
                                ? showImage('Admin/Assets/pdfIcon2.png')
                                : showImage(item.commentImage)
                            "
                            class="chat-imgset object-contain w-full bg-f4f5f6 px-3 pt-2"
                            alt="image"
                            @click="
                              item.isPdfUpload
                                ? openPdf(item.commentImage)
                                : getImage(item.commentImage)
                            "
                          />
                        </div>

                        <p
                          class="font-medium text-left px-4 py-2 fitcontent text-dark fsize12 rounded-lg"
                        >
                          {{ item.comment }}
                        </p>
                      </div>
                      <span class="fsize10 text-8f8f8f flex justify-end pt-2">{{
                        getDate(item.createdAt)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="absolute bottom-0 left-0 w-full p-6">
                <!-- image preview -->
                <div
                  class="grid grid-cols-6 bg-input p-3 w-11/12 bordb gap-4"
                  v-if="image"
                >
                  <div class="relative">
                    <img
                      :src="this.image ? this.image : ''"
                      class="object-cover w-full h-24 bg-light-primary border-round"
                      :alt="this.file.name"
                    />
                    <div class="absolute top-0 right-0 margin-minu">
                      <feather-icon
                        icon="XIcon"
                        svgClasses="w-4 h-4"
                        class="text-white flex p-1 bg-primary rounded-full justify-center items-center"
                        @click="
                          () => {
                            this.image = '';
                            this.file = {};
                          }
                        "
                      >
                      </feather-icon>
                    </div>
                    <p
                      class="font-medium text-dark fsize10 mb-0 rounded-lg p-4"
                    >
                      {{ this.file.name }}
                    </p>
                  </div>
                  <!-- <div class="relative" v-else>
                    <feather-icon icon="FileIcon" />
                    <div class="absolute top-0 right-0 m-3">
                      <feather-icon
                        icon="XIcon"
                        svgClasses="w-4 h-4"
                        class="text-white flex justify-center items-center"
                        @click="
                          () => {
                            this.image = '';
                            this.file = {};
                          }
                        "
                      >
                      </feather-icon>
                    </div>
                  </div> -->
                </div>
                <div class="gap-4 flex items-center">
                  <div class="relative w-11/12">
                    <input
                      placeholder="Type a Message"
                      type="text"
                      class="chatinput w-full"
                      ref="CommentField"
                      v-model="comment"
                      v-on:keyup.enter="addComment"
                    />
                    <!-- image upload -->
                    <div class="">
                      <div class="cursor-pointer cust-feather">
                        <feather-icon
                          icon="LinkIcon"
                          svgClasses="w-4 h-4 cursor-pointer "
                        />
                        <div class="absolute top-0 left-0 opacityd">
                          <input
                            class="w-4 h-4 cursor-pointer"
                            type="file"
                            @change="handleUpload"
                            v-on:keyup.enter="addComment"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="bg-primary w-12 h-12 flex justify-center items-center rounded-4px cursor-pointer"
                  >
                    <feather-icon
                      icon="ArrowRightIcon"
                      class="text-white flex justify-center items-center"
                      @click="addComment"
                    >
                    </feather-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- chatexpert lock -->
          <div
            v-if="!isShowChat"
            :class="{ 'bg-lightchat': isShowChat == false }"
            class="absolute top-0 left-0 w-full h-full rounded-10px flex justify-center items-center"
          >
            <div class="w-7/12 text-center">
              <feather-icon
                icon="LockIcon"
                class="text-f4f5f6"
                svgClasses="w-32 h-32"
              />
              <div class="mt-4" v-if="isActive">
                <h4 class="text-white fsize18 font-semibold">
                  Request Assistance
                </h4>

                <p class="text-white fsize12">
                  Get some changes you'd like to request? we can iterate the
                  design once more. please specify the changes you wish to
                  implement in the chat.
                </p>

                <vs-button
                  type="primary"
                  class="bg-primary mt-2 text-white font-medium fsize14 py-4 px-10 mt-2 sm-fsize14 rounded-full border-none"
                  @click="chatPayment()"
                >
                  Chat with an expert
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import { mapState } from "vuex";
import { EventBus } from "@/main";
import moment from "moment";
import axios from "axios";
import { log } from "console";
import FeatherIcon from "../../../../../components/FeatherIcon.vue";
import SendPopUp from "./components/SendPopUp.vue";

export default {
  components: { FeatherIcon, SendPopUp },
  data() {
    return {
      isShowChat: true,
      comment: "",
      isActive: true,
      isShowChatImage: false,
      imagePreview: "",
      chatLimit: false,
      chats: [],
      isPdf: false,
      isFileType: false,
      isFileSize: false,
      centerDialogVisible: false,
      centerDialogVisible1: false,
      textarea: "",
      value1: 4,
      datavalue: "",
      data: "",
      image: "",
      file: {},
      isEditFeedback: false,
    };
  },
  methods: {
    editFeedBackPopup() {
      this.centerDialogVisible = true;
      this.isEditFeedback = true;
      this.textarea = this.selectedreq.feedback[0].feedbackDes;
      this.value1 = this.selectedreq.feedback[0].feedbackRating;
    },
    async editFeedback() {
      let data = await this.$store.dispatch("studio/editRequest", {
        projectName: this.selectedProject.projectName,
        requestId: this.selectedreq._id,
        feedbackRating: this.value1,
        feedbackDes: this.textarea,
      });

      this.centerDialogVisible = false;
      this.textarea = "";
      this.value1 = 0;
      let loader = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      await this.getSelectedRequest();
      loader.close();
    },
    async downloadImg(file, fileName) {
      // this.link = file;
      // let url = await this.remoteURL();
      // fetch(url)
      //   .then((response) => response.blob())
      //   .then((blob) => {
      //     url.saveAs(blob, "image.jpg");
      //   });

      let image_url =
        // "https://nimbuscluster.blob.core.windows.net/server01/" + file;
        `${this.$imageURL}${file}`;

      let downloadImg = await axios.get(image_url, { responseType: "blob" });

      let imageBlog = new Blob([downloadImg.data]);
      const imageUrl = URL.createObjectURL(imageBlog);
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    remoteURL() {
      return this.link;
    },

    showImage(value) {
      let default_image = require("@/assets/images/card1.png");

      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
    openPdf(link) {
      let image_base_url = this.$imageURL;
      this.data = `${image_base_url}/${link}`;
      window.open(this.data, "_blank");
    },

    async handleUpload(e) {
      console.log(this.image, "image");
      this.file = e.target.files[0];
      console.log(this.file, "file");
      if (
        this.file.type === "image/jpeg" ||
        this.file.type === "image/png" ||
        this.file.type === "application/pdf"
      ) {
        if (this.file.size <= 375000) {
          const reader = new FileReader();
          if (this.file.type === "application/pdf") {
            this.image = this.$imageURL + "/Admin/Assets/pdfIcon2.png";
          } else {
            this.image = await this.convertToBase64(e.target.files[0]);
          }
        } else {
          this.isFileSize = true;
          this.file = {};
        }
      } else {
        this.isFileType = true;
        this.file = {};
      }
      this.$refs.CommentField.focus();
    },
    convertToBase64(file) {
      return new Promise(async (resolve, reject) => {
        let reader = new FileReader();
        await reader.readAsDataURL(file);

        reader.onloadend = await function () {
          resolve(reader.result);
        };
      });
    },
    async editRequest() {
      // this.isActive = false;
      // this.isShowChat = false;
      this.$swal({
        title: "Are you sure you want to Sign-Off?",
        type: "Warning",
        showCancelButton: true,
        confirmButtonColor: "#cd3197",
        confirmButtonText: "Yes, I want to",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          this.centerDialogVisible = true;
          await this.$store.dispatch("studio/editRequest", {
            projectName: this.selectedProject.projectName,
            requestId: this.selectedreq._id,
            chatPaymentStatus: "Pending",
            status: "Signed Off",
            isSignOff: true,
          });
        }
      });
      // await this.getSelectedRequest();
    },
    async addFeedback() {
      let data = await this.$store.dispatch("studio/editRequest", {
        projectName: this.selectedProject.projectName,
        requestId: this.selectedreq._id,
        feedbackRating: this.value1,
        feedbackDes: this.textarea,
      });

      this.centerDialogVisible = false;
      await this.$router.push({ name: "studio" });
    },
    async closeFeedback() {
      this.centerDialogVisible = false;
    },
    async addComment() {
      // let payload1 = {
      //   projectName: this.selectedProject.projectName,
      //   projectId: this.selectedProject._id,
      //   // projectId: this.selectedreq.projectId._id,
      //   // projectName: this.selectedreq.projectId.projectName,
      //   requestId: this.selectedreq._id,
      //   comment: this.comment,
      //   commentImage: this.image ? this.image : "",
      //   commentOrigin: "Admin",
      //   user: this.selectedProject._id,
      // };

      // let { requestdata } = await this.$store.dispatch(
      //   "studio/addComments",
      //   payload1
      // );
      // this.comment = "";
      // this.getcommentsfunc();
      // this.chatsFunc();
      if (this.comment != "" && !this.file.size > 0) {
        let payload1 = {
          projectName: this.selectedProject.projectName,
          projectId: this.selectedProject._id,
          requestId: this.selectedreq._id,
          comment: this.comment,
          commentOrigin: "Admin",
          user: this.selectedProject._id,
        };

        let { requestdata } = await this.$store.dispatch(
          "studio/addComments",
          payload1
        );
        this.comment = "";
        this.getcommentsfunc();
        this.chatsFunc();
      } else if (this.file.size > 0 && this.comment === "") {
        if (this.file.type === "application/pdf") {
          this.isPdf = true;
        } else {
          this.isPdf = false;
        }

        let formData = new FormData();
        let payload = {
          projectName: this.selectedProject.projectName,
          projectId: this.selectedProject._id,
          requestId: this.selectedreq._id,
          commentImage: this.image ? this.image : "",
          isPdfUpload: this.isPdf,
          commentOrigin: "Admin",
          user: this.selectedProject._id,
        };

        formData.append("commentImage", this.file);

        let requiredData = Object.entries(payload);
        for (let i = 0; i < requiredData.length; i++) {
          formData.append(requiredData[i][0], requiredData[i][1]);
        }

        let { data } = await this.$store.dispatch(
          "studio/addComments",
          formData
        );

        this.comment = "";
        this.file = {};
        this.image = "";
        this.getcommentsfunc();
        this.chatsFunc();
      } else if (this.file.size > 0 && this.comment != "") {
        if (this.file.type === "application/pdf") {
          this.isPdf = true;
        } else {
          this.isPdf = false;
        }
        let formData = new FormData();
        let payload = {
          projectName: this.selectedProject.projectName,
          projectId: this.selectedProject._id,
          requestId: this.selectedreq._id,
          commentImage: this.image ? this.image : "",
          isPdfUpload: this.isPdf,
          comment: this.comment,
          commentOrigin: "Admin",
          user: this.selectedProject._id,
        };

        formData.append("commentImage", this.file);

        let requiredData = Object.entries(payload);
        for (let i = 0; i < requiredData.length; i++) {
          formData.append(requiredData[i][0], requiredData[i][1]);
        }

        let { data } = await this.$store.dispatch(
          "studio/addComments",
          formData
        );

        this.comment = "";
        this.file = {};
        this.image = "";
        this.getcommentsfunc();
        this.chatsFunc();
      }
    },

    async getcommentsfunc() {
      let payload2 = {
        // projectId: this.selectedreq.projectId._id,
        // projectName: this.selectedreq.projectId.projectName,
        projectName: this.selectedProject.projectName,
        projectId: this.selectedProject._id,
        requestId: this.selectedreq._id,
      };
      let { data } = await this.$store.dispatch("studio/getComments", payload2);
      let chatheight = document.getElementById("chatwindow");
      let height = chatheight.scrollHeight;
      this.$refs.chat.scrollTo(0, height);

      // this.chats = data.filter((x) => (x.commentOrigin = "Admin"));
      // console.log(this.chats, "admin chtas");
    },
    async chatsFunc() {
      let payload2 = {
        projectName: this.selectedProject.projectName,
        projectId: this.selectedProject._id,
        requestId: this.selectedreq._id,
      };
      let { data } = await this.$store.dispatch("studio/getComments", payload2);
      // this.chats = data.filter((x) => x.commentOrigin === "Admin");
      // console.log(this.chats, "data");
      // if (this.chats.length >= 3) {
      //   this.isShowChat = false;
      // }
    },
    // chatModuleFunc() {
    //   if (this.selectedreq.uploadHistory.length >= 3) {
    //     this.isShowChat = false;
    //   }
    //   // if (Object.entries(this.selectedreq.uploadHistory).length) {
    //   //   this.isShowChat = false;
    //   // }
    // },
    async getSelectedRequest() {
      console.log("selected called");
      let { data } = await this.$store.dispatch("studio/getSelectedRequest", {
        projectName: this.selectedProject.projectName,
        projectId: this.selectedProject._id,
        requestId: this.selectedreq._id,
      });
      console.log(data, "selected called");
      // if (data && data[0].status === "Signed Off")
      if (data.data.status || data.data[0].status === "Signed Off") {
        this.isActive = false;
        this.isShowChat = false;
      }
      // if (data && data[0].status === "Delivered")
      if (data.data.status || data.data[0].status === "Delivered") {
        this.isActive = false;
        this.isShowChat = false;
      }
      // // if (data && data[0].chatPaymentStatus === "Paid")
      if (
        data.data.chatPaymentStatus ||
        data.data[0].chatPaymentStatus === "Paid"
      ) {
        this.isShowChat = true;
      }
      // else if (
      //   data &&
      //   data[0].chatPaymentStatus === "Pending" &&
      //   data[0].uploadHistory < 3
      // ) {
      //   this.isShowChat = true;
      // }
      else {
        this.isShowChat = false;
      }
    },

    getImage(value) {
      this.isShowChatImage = true;
      console.log(value, "value");
      this.imagePreview = this.showImage(value);
    },
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    async chatPayment() {
      const { data } = await this.$store.dispatch("studio/createOrder", {
        userId: this.login._id,
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        amount: 300,
        studioId: this.selectedreq._id,
        currency: "INR",
        orderType: "Chat",
      });

      const options = {
        key: process.env.VUE_APP_RAZORPAY_KEY,
        // amount: 300,
        currency: "INR",
        order_id: data.orderId,
        prefill: {
          name: this.login.name,
          email: this.login.email,
          contact: this.login.mobile,
        },
        handler: async (response) => {
          const req_data = await this.$store.dispatch("studio/editRequest", {
            requestId: this.selectedreq._id,
            projectName: this.selectedProject.projectName,
            projectId: this.selectedProject._id,
            chatPaymentId: data._id,
            chatPaymentStatus: "Paid",
          });
          this.getSelectedRequest();
        },
      };
      const rzp = await new Razorpay(options);
      rzp.open();
    },
  },
  computed: {
    ...mapState("studio", [
      "selectedreq",
      "addcomments",
      "getcomments",
      "previousRoute",
    ]),
    ...mapState("admin", ["login"]),

    ...mapState("user", ["selectedProject"]),
  },
  mounted() {
    // this.$store.commit("studio/UPDATED_REQUEST", []);
    this.getSelectedRequest();
    this.getcommentsfunc();
    this.chatsFunc();
    // this.chatModuleFunc();

    EventBus.$on("TriggerGetComments", this.getcommentsfunc);
  },
};
</script>
|
<style>
.ne-oppo-new .el-dialog__header {
  display: none !important;
}
.headerbg .el-dialog__header {
  background-color: #fff !important;
}
.el-dialog__headerbtn .el-dialog__close {
  color: black !important;
}
.w150px {
  width: 150px !important;
}
.h150px {
  height: 150px !important;
}
</style>
